import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { CreatePlanoInput, createPlanoSchema, planos } from 'service/api'
import { toast } from 'sonner'
import { FormPlano } from '../forms/FormPlano'

export default function AdicionarPlano() {
    const { mutateAsync, isLoading } = planos.mutations.useCreate({
        invalidateQuery: true,
    })

    function handleSubmit(data: CreatePlanoInput) {
        return mutateAsync(data, {
            onSuccess: () => {
                toast.success('Plano adicionado com sucesso!')
            },
            onError: err => {
                toast.error(`Erro ao adicionar plano: ${err.message}`)
            },
        })
    }

    return (
        <Dialog.Root
            open={hasPermission(['create', 'Planos e preços'])}
            width="xl"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={createPlanoSchema}
        >
            <Dialog.Title>Adicionar plano</Dialog.Title>
            <Dialog.Content>
                <FormPlano />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
